import React from 'react';
import { pdfFiles } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const ProblemSolving = () => {
  const problemSolvingPdf = pdfFiles.strategiesPart2.find(
    (pdf) => pdf.name === 'Steps to Problem Solving',
  );

  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter pdfFile={problemSolvingPdf} vidSrc={1196355783} />
    </div>
  );
};

export default ProblemSolving;
